import React from 'react';
import { useApiKey } from '../context/ApiKeyContext';

const ApiKeyRequiredModal: React.FC = () => {
  const {
    showKeyRequiredModal,
    closeKeyRequiredModal,
    openKeyModal,
  } = useApiKey();

  if (!showKeyRequiredModal) return null;

  const handleAddKey = () => {
    closeKeyRequiredModal();
    openKeyModal();
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-50 p-4"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.92)' }}
      onClick={closeKeyRequiredModal}
    >
      <div
        style={{
          backgroundColor: '#000000',
          border: '2px solid #ffffff',
          borderRadius: 0,
          maxWidth: '32rem',
          width: '100%',
          padding: '2rem',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ marginBottom: '1.5rem', textAlign: 'center' }}>
          <h2
            style={{
              fontSize: '1.5rem',
              fontWeight: 700,
              color: '#ffffff',
              marginBottom: '0.75rem',
              fontFamily: "'Inter', sans-serif",
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
            }}
          >
            API Key Required
          </h2>
          <p
            style={{
              color: 'rgba(255, 255, 255, 0.85)',
              fontSize: '0.95rem',
              fontFamily: "'Inter', sans-serif",
              lineHeight: 1.5,
            }}
          >
            Please add an API key to analyze conversations.
          </p>
        </div>

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
          <button
            onClick={closeKeyRequiredModal}
            style={{
              background: 'transparent',
              border: '1px solid #ffffff',
              color: '#ffffff',
              padding: '0.6rem 1.5rem',
              fontSize: '0.9rem',
              fontWeight: 600,
              letterSpacing: '0.05em',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              fontFamily: "'Inter', sans-serif",
              borderRadius: 0,
              textTransform: 'uppercase',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#ffffff';
              e.currentTarget.style.color = '#000000';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.color = '#ffffff';
            }}
          >
            Close
          </button>
          <button
            onClick={handleAddKey}
            style={{
              background: '#ffffff',
              border: '1px solid #ffffff',
              color: '#000000',
              padding: '0.6rem 1.5rem',
              fontSize: '0.9rem',
              fontWeight: 600,
              letterSpacing: '0.05em',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              fontFamily: "'Inter', sans-serif",
              borderRadius: 0,
              textTransform: 'uppercase',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.color = '#ffffff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#ffffff';
              e.currentTarget.style.color = '#000000';
            }}
          >
            Add API Key
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApiKeyRequiredModal;
